import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";

interface SkinProductHeaderProps {
  skinName: string;
}

export const SkinProductHeader = ({ skinName }: SkinProductHeaderProps) => {
  return (
    <SSHeadline props={{ title: { fz: 24 } }}>
      <Emoji.Fire />
      <SSLoLGradientText>{skinName.toUpperCase()}</SSLoLGradientText>
    </SSHeadline>
  );
};
